import React, { Component } from 'react'
import { GetData } from '../../../api/service'
import { Typography, Table, TableHead, TableRow, TableCell, TableBody, Button } from '@material-ui/core'
import Edit from '@material-ui/icons/Edit'

export default class GalleryLanding extends Component {
    state = {
        list: [],
        isLoaded: false
    }

    componentDidMount() {
        GetData(`/${this.props.apikey}/getgallery`)
            .then((resp) => {
                this.setState({
                    list: resp,
                    isLoaded: true
                })
            })
    }

    render() {
        return (
            <div>
                <Typography variant="h6">
                    Gallery
            </Typography>

                <div align="right">
                    <Button variant="contained" color="primary" onClick={() => this.props.history.push('/gallery/add')}>
                        Add Gallery
            </Button>
                </div>
                <br />
                <Table size="small" style={{backgroundColor: '#fff'}}>

                    <TableHead>
                        <TableRow>
                            <TableCell width="5%">#</TableCell>
                            <TableCell width="15%">Dept Code</TableCell>
                            <TableCell width="65%">Description</TableCell>
                            <TableCell width="65%">Image</TableCell>
                            <TableCell width="5%">Edit</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {this.state.list.map((el, index) =>
                            <TableRow key={index} style={{ verticalAlign: 'top' }}>
                                <TableCell>{index + 1}</TableCell>
                                <TableCell>{el.dept_code}</TableCell>
                                <TableCell dangerouslySetInnerHTML={{ __html: el.description }}></TableCell>

                                <TableCell>
                                    {el.image.map((el1,index1) => <img key={index1} src={el1.url} style={{width: 300}} />)}
                                </TableCell>
                                <TableCell><Edit onClick={() => this.props.history.push('/gallery/edit', el)} /></TableCell>
                            </TableRow>
                        )}
                    </TableBody>

                </Table>


            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/Components/Department/Gallery/GalleryLanding.js